import React, { useState } from 'react'
import {
  Button,
  TextField,
  Typography,
  Paper
} from '@material-ui/core'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom'

function ResetPassword() {

  const location = useLocation()
  const navigate = useNavigate()

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const [passwordValidation, setPasswordValidation] = useState({
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  })

  const token = new URLSearchParams(location.search)
    .get('token')

  const validatePassword = (password: string) => {

    return {
      minLength: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[^A-Za-z0-9]/.test(password),
    }
  }

  const handleResetPassword = async () => {

    try {

      setError('')

      if (!password.trim()) {
        setError('Digite a nova senha')
        return
      }

      const validation = validatePassword(password)

      const isPasswordValid =
        Object.values(validation).every(Boolean)

      if (!isPasswordValid) {
        setError(
          'A senha não atende os requisitos'
        )
        return
      }

      if (password !== confirmPassword) {
        setError('As senhas não coincidem')
        return
      }

      setLoading(true)

      await axios.post(
        `${process.env.REACT_APP_BACKEND}/reset-password-cliente`,
        {
          token,
          password
        }
      )

      alert('Senha alterada com sucesso!')

      navigate('/login')

    } catch (error: any) {

      setError(
        error?.response?.data?.message ||
        'Erro ao redefinir senha'
      )

    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f4f4f4'
      }}
    >
      <Paper
        elevation={3}
        style={{
          width: 400,
          padding: 30,
          display: 'flex',
          flexDirection: 'column',
          gap: 20
        }}
      >
        <Typography
          variant="h5"
          style={{
            color: '#1A3661',
            fontWeight: 700
          }}
        >
          Redefinir Senha
        </Typography>

        <TextField
          label="Nova senha"
          type="password"
          variant="outlined"
          fullWidth
          value={password}
          onChange={(e) => {

            const value = e.target.value

            setPassword(value)

            setPasswordValidation(
              validatePassword(value)
            )
          }}
        />

        <TextField
          label="Confirmar senha"
          type="password"
          variant="outlined"
          fullWidth
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value)
          }}
        />

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4
          }}
        >
          <span
            style={{
              fontSize: 12,
              color: passwordValidation.minLength
                ? '#2e7d32'
                : '#d32f2f'
            }}
          >
            • Mínimo de 8 caracteres
          </span>

          <span
            style={{
              fontSize: 12,
              color: passwordValidation.uppercase
                ? '#2e7d32'
                : '#d32f2f'
            }}
          >
            • Pelo menos 1 letra maiúscula
          </span>

          <span
            style={{
              fontSize: 12,
              color: passwordValidation.lowercase
                ? '#2e7d32'
                : '#d32f2f'
            }}
          >
            • Pelo menos 1 letra minúscula
          </span>

          <span
            style={{
              fontSize: 12,
              color: passwordValidation.number
                ? '#2e7d32'
                : '#d32f2f'
            }}
          >
            • Pelo menos 1 número
          </span>

          <span
            style={{
              fontSize: 12,
              color: passwordValidation.special
                ? '#2e7d32'
                : '#d32f2f'
            }}
          >
            • Pelo menos 1 caractere especial
          </span>
        </div>

        {!!error && (
          <Typography
            style={{
              color: '#d32f2f',
              fontSize: 14
            }}
          >
            {error}
          </Typography>
        )}

        <Button
          variant="contained"
          disabled={loading}
          onClick={handleResetPassword}
          style={{
            backgroundColor: '#1A3661',
            color: '#fff',
            height: 45
          }}
        >
          {loading
            ? 'Alterando...'
            : 'Alterar Senha'}
        </Button>
      </Paper>
    </div>
  )
}

export default ResetPassword